import React from "react";
import PropTypes from "prop-types";

import { EntityFormHeader } from "../../../common/entity-form";

import CustomRoleFormHeaderTitle from "./custom-role-form-page-header-title.jsx";

const CustomRoleFormPageHeader = ({
    customRoleId,
    mode,
    onBackClick,
}) => {
    return (
        <EntityFormHeader>
            <CustomRoleFormHeaderTitle
                customRoleId={customRoleId}
                mode={mode}
                onBackClick={onBackClick}
            />

            {/* <EntityFormActions
                mode={mode}
                onDeleteClick={onDeleteClick}
                onSaveClick={onSaveClick}
                onEditClick={onEditClick}
                onShowLogsClick={onShowLogsClick}
            /> */}
        </EntityFormHeader>
    );
};

CustomRoleFormPageHeader.propTypes = {
    customRoleId: PropTypes.string,
    mode: PropTypes.string,
    onBackClick: PropTypes.func,
}

export default CustomRoleFormPageHeader;
